/* unplugin-vue-components disabled */import script from "./perm-error.vue?vue&type=script&setup=true&lang=js"
export * from "./perm-error.vue?vue&type=script&setup=true&lang=js"

import "./perm-error.vue?vue&type=style&index=0&id=32b25176&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b25176"]])

export default __exports__